import { Link } from "react-router-dom";

const ENTRIES = [
  {
    to: "/movie",
    label: "电影频道",
    desc: "动作、喜剧、科幻、悬疑，各类大片一网打尽",
    icon: "ri-film-line",
    count: "6 部精选",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20collage%20of%20a%20dark%20movie%20theater%20with%20glowing%20amber%20projector%20beam%20and%20dusty%20air%2C%20deep%20blue%20and%20charcoal%20tones%20with%20warm%20highlights%2C%20artistic%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1200&height=700&seq=home-cat-movie&orientation=landscape",
  },
  {
    to: "/tv",
    label: "电视剧频道",
    desc: "国产、欧美、日韩，热门新剧与经典剧集齐备",
    icon: "ri-tv-2-line",
    count: "6 部精选",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20scene%20of%20a%20cozy%20dark%20living%20room%20with%20a%20glowing%20screen%2C%20deep%20blue%20and%20charcoal%20tones%20with%20warm%20amber%20lamp%20light%2C%20inviting%20storytelling%20mood%2C%20artistic%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1200&height=700&seq=home-cat-tv&orientation=landscape",
  },
];

export default function CategoryEntry() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14" aria-label="分类快捷入口">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative block h-44 overflow-hidden rounded-lg border border-background-800 md:h-56"
          >
            <img
              src={entry.image}
              alt={`${entry.label}入口`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/70 to-background-950/30"></div>
            <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-8">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-background-950">
                <i className={`${entry.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold text-foreground-50 md:text-2xl">{entry.label}</h3>
              <p className="mt-1 max-w-sm text-sm text-foreground-300">{entry.desc}</p>
              <span className="mt-3 flex items-center gap-1.5 text-sm font-medium text-accent-400">
                {entry.count}
                <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}